import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LinkComponent } from '@teamfoster/sdk/button';
import { StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { SafePipe } from '@teamfoster/sdk/text-utility';

import { Header } from '../../models/header.model';
import { Image } from '@teamfoster/sdk/image';

@Component({
    selector: 'app-header-standard',
    imports: [ResizeHtmlImagesPipe, StripEmbedPipe, SafePipe, LinkComponent],
    templateUrl: './header-standard.component.html',
    styleUrl: './header-standard.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderStandardComponent {
  header = input<Header>();
  title = input<string>();
  subTitle = input<string | null>();
  intro = input<string | null>();
  image = input<Image | null>();

  theme = input<'accent' | 'secondary'>('accent');

  cleanIntro = computed(() => {
    const intro = this.intro();

    // remove all <p><br></p> from intro
    return intro?.replace(/<p><br><\/p>/g, '');
  });
}
